import { FgPriceListCategoryEnum, FgPriceListColumns, FgPriceListRequest, FgPriceListResponseModel, ProductAndCategoryReq } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { FgpriceList } from "./fg-pricelist-entity";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { Product } from "../products/product.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { FgpriceListLogs } from "./fg-pricelist-logs-entity";
import { SkuCodes } from "../sku-codes/sku-codes.entity";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@Injectable()

export class FgPriceListService{
    constructor(
        @InjectRepository(FgpriceList) private repo: Repository<FgpriceList>
    ){}
  
    async createFgPriceList(req : any): Promise<FgPriceListResponseModel> {
        console.log(req,'reqqqqqqqqqqqqqqqqqqqqq');
        
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction()
            const flag = new Set<boolean>()
            const columnArray = []
            const updatedArray = req.data.map((obj) => {
                const updatedObj = {}
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            })
            const difference = columnArray.filter((element) => 
            !FgPriceListColumns.includes(element));
            console.log(difference,"difference")
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new FgPriceListResponseModel(false, 1110, "Excel columns doesn't match. Please attach the correct file.");
            }

            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === "") {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            for (const rec of convertedData) {
             const val = (Object.values(FgPriceListCategoryEnum).includes(rec.category)) 
             console.log(val,'000000000000');
             
                const product = await transactionManager.getRepository(SkuCodes).findOne({where:{shortCode:rec.Product}})
                console.log(product,'productttttttttttttt');
                
                const existingData = await transactionManager.getRepository(FgpriceList).findOne({ where:{ productId:{skuCodeId:product.skuCodeId},category:rec.Category} ,relations:['productId']});
    
                if (existingData) {
                    // existingData.price = rec.Price;
                    const updatedData = await transactionManager.getRepository(FgpriceList).update({id:existingData.id},{highPrice:rec.HighPrice,midPrice:rec.MidPrice,minPrice:rec.MinPrice,updatedUser:existingData.createdUser});
                    
                    if (updatedData.affected) {
                        const logs = new FgpriceListLogs()
                        logs.FgpriceListId = new FgpriceList()
                        logs.FgpriceListId.id = existingData.id
                        logs.effectiveFrom = existingData.createdAt
                        logs.highPrice = existingData.highPrice
                        logs.midPrice = existingData.midPrice
                        logs.minPrice = existingData.minPrice

                        // logs.productId = new Product()
                        logs.createdUser = existingData.createdUser
                        // logs.FgpriceListId = existingData.id
                         const dataaaaaaa =   await transactionManager.getRepository(FgpriceListLogs).save(logs);
                         
                        flag.add(true);
                        // await transactionManager.releaseTransaction()
                    } 
                } else {
                    const product = await transactionManager.getRepository(SkuCodes).findOne({where:{shortCode:rec.Product}})

                                    const fgPriceListEntity = new FgpriceList()
                                    fgPriceListEntity.createdUser = req.user
                                    // fgPriceListEntity.updatedUser = req.updatedUser
                                    fgPriceListEntity.category = rec.Category
                                    fgPriceListEntity.productId = new SkuCodes()
                                    fgPriceListEntity.productId.skuCodeId = product.skuCodeId
                                    fgPriceListEntity.highPrice = rec.HighPrice
                                    fgPriceListEntity.midPrice = rec.MidPrice
                                    fgPriceListEntity.minPrice = rec.MinPrice
                    
                    const savedData = await transactionManager.getRepository(FgpriceList).save(fgPriceListEntity);
    
                    if (savedData) {
                        flag.add(true);
                    } else {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new FgPriceListResponseModel(false, 0, 'Something went wrong in saving new data');
                    }
                }
            }
        
        if (!flag.has(false)) {
                        await transactionManager.completeTransaction();
                        return new FgPriceListResponseModel(true, 1, 'Data saved successfully');
                    } else {
                        await transactionManager.releaseTransaction();
                        return new FgPriceListResponseModel(false, 0, 'Something went wrong');
                    }
                } catch (err) {
            await transactionManager.releaseTransaction();
            return new FgPriceListResponseModel(false, 0, 'Something went wrong');
        }
    }
 
    async getAllFgPriceListInfo(): Promise<FgPriceListResponseModel> {
        try {
            let res = []
            const info = await this.repo.find({relations:['productId']})
            console.log(info,'ppppppppp');
            
            if (info.length>0) {
                for(const data of info ){
                    res.push(new FgPriceListRequest(data.id,data.productId.skuCodeId,data.category,data.createdUser,data.updatedUser,data.productId.shortCode,data.isActive,data.versionFlag,data.highPrice,data.minPrice,data.midPrice,data.updatedAt))
                }
                return new FgPriceListResponseModel(true, 1,'Data retrieved',res)
            } else {
                return new FgPriceListResponseModel(false, 0,'No data found')
            }
        } catch (err) {
            return new FgPriceListResponseModel(false, 0, 'Something went wrong', err)
        }
    }

    async getProductPriceByProductAndCategory(req:ProductAndCategoryReq):Promise<CommonResponse>{
        try{
            const data = await this.repo.find({where:{productId:req.productId,category:req.category}})
            if(data.length >0){
                return new CommonResponse(true,1,'Data retrieved',data)
            }else{
                return new CommonResponse(false,0,'No data found')
            }

        }catch(err){
            throw err
        }
    }
}